import axios from "axios";
import {TFetchPrefixesReturn, IGetCustomersParams, IGetIssuePlacesParams, TGetCommonPlacesReturn, TGetIssuePlacesReturn, IGenericOption} from "../../models/models";

// PATHS
const RA_ENDPOINT = '/network/ra';
const RA_ENDPOINT_RAFILLING = '/network/ra';
const RA_ENDPOINT_KEYLESS = '/network/ra-keyless';

const RA_CHECK = '/network/ra/check';
const RA_GET_CUSTOMER_DATA = '/network/ra/getCustomerData';
const RA_UPDATE_DRAFT_DATA = '/network/ra/updateDraftRA';
const RA_DRAFT_DATA = '/network/ra/getDraftRA/';
const RA_VERIFY_SIGN = '/network/ra/verify-sign/';
const RA_CHECK_TRANSACTION = '/network/payment/check-transaction';
const RA_PREFIXES_DATA = '/network/common/prefixes';
const RA_COUNTRIES_DATA = '/network/common/countries';
const RA_LEGALENTITIES_DATA = '/network/common/legal-entities';
const RA_VEHICLE_IDENTIFICATION_BY_ID_RA = '/network/ra/{id}/checkoutin/{outin}';
const RA_PROVINCES_BY_COUNTRY_DATA = '/network/common/countries/{countryCode}/provinces';
const PRE_AUTH = '/network/ra-payment?paymentCreateRequestType=';
const RA_VERIFY_EMAIL_MOBILE_OTP_VALIDATION = "/network/ra/verifyemailandmobile";
const RA_SEND_OTP_VALIDATION = "/network/ra/sendOtp";
const RA_CHECK_OTP_VALIDATION = "/network/ra/checkOtp";
const RA_CONSENT = '/network/ra/consentManagement';
const RA_VEHICLE_EQUIPMENTS_DEFAULT = '/network/vehicle-mng/vehicleGetAllDefaultEquipmentsByTenantAndPlate';
const RA_VEHICLE_EQUIPMENTS_CHECK_OUT_IN = '/network/vehicle-mng/vehicleGetAllCheckInOutEquipmentsByTenantAndPlate';
const RA_VEHICLE_DAMAGES = '/network/vehicle-mng/getExistingByTenantAndVinOrPlate';
const RA_PREAUTH_PAYMENT_VERIFY = "/network/payment/verify";
const RA_PREAUTH_PAYMENT_PREAUTHORIZE = "/network/payment/preauthorize";
const RA_PREAUTH_PAYMENT_DISPOSITIVE = "/network/payment/dispositive";
const RA_PREAUTH_PAYMENT_INVOICE_DRAFT = "/network/payment/invoice-draft/";
const RA_PREAUTH_PRICE_LIST = "/network/payment/pricelist-preauth";
const RA_PREAUTH_VERITY_PAYMENT_STATUS = "/network/payment/verifypaymentstatus";
const RA_UPDATE_BY_COUNTER_SALE = "/network/ra/update-by-counter-sale";
const AVAILABLE_ANCILLARIES = '/pricing/available-ancillaries'
const DOWNLOAD_PDF = '/network/ra/downloadPdf/';
const RA_QRCODE_SIGNRA = '/network/ra/qrcodesignra';
const CUSTOMERS = '/network/ra/customers';
const COMMON_PLACES = '/network/common/places';
const ISSUE_PLACES = 'network/common/issueplaces';
const COUNTER_SALE_MANAGEMENT = '/network/ra/counter-sale-mng';
const FIND_COUNTER_SALE_MANAGEMENT = '/network/ra/find-counter-sale-mng';
const CREATE_RA_PRICING_ANCILLARY_INFO = '/network/pricing/ancillary-info';
const LIST_VEHICLES_RRE = '/network/vehicle/{tenant}/location/rre';
const VALIDATE_DOCUMENTS_DRIVER = '/network/ra/validDocuments'
const BUSINESS_CONTINUITY_SKIP_PAYMENT = '/network/ra/business-continuity/skipPayment';
const RA_UPLOAD_RECEIPT = '/network/ra/upload-receipt';
const RA_RECOVERY_RECEIPT = '/network/ra/recovery/upload-documents';
const RA_CHECK_IN_EXTRA = '/network/check-in-extra';

const ra: any = async (req: any) => {
	const language = req.language;
	delete req.language;

	const response = await axios.post(RA_ENDPOINT + (!!language ? `?language=${language}` : ''), req);
	return response.data;
}
// RA_ENDPOINT_RAFILLING
const raFilling: any = async (req: any) => {
	const keylessParams = req.keyless
		? `&keyless=true&keylessInfo=${encodeURIComponent(req.keyLessInfo || '')}`
		: '';
	const response = await axios.post(RA_ENDPOINT_RAFILLING + `?raFilling=1&updateRa=${req.updateRa}${keylessParams}`, req.params);
	return response.data;
}

const raKeyless: any = async (req: any) => {
	const language = req.language;
	delete req.language;

	const { keyless, keylessInfo } = req;
	delete req.keyless;
	delete req.keylessInfo

	const keylessParams = keyless
		? `${!!language ? '&' : '?'}keyless=true&keylessInfo=${encodeURIComponent(keylessInfo || '')}`
		: ''

	const response = await axios.post(RA_ENDPOINT_KEYLESS + (!!language ? `?language=${language}` : '') + keylessParams, req);
	return response.data;
}

const raEdit: any = async (req: any) => {
	const { keyless, keylessInfo } = req;
	delete req.keyless;
	delete req.keylessInfo

	const keylessParams = `editRa=true&keyless=true&keylessInfo=${encodeURIComponent(keylessInfo || '')}`

	const response = await axios.post(RA_ENDPOINT_KEYLESS + '?' + keylessParams, req);
	return response.data;
}

const raCheck: any = async (req: any) => {
	const response = await axios.post(RA_CHECK, req);
	return response.data;
}

const listVehiclesReadyToRent: any = async (req: any) => {
	const path = LIST_VEHICLES_RRE.replace('{tenant}', req.tenant);
	delete req.tenant;
	const response = await axios.post(path, req);
	return response.data;
}

const fetchAvailableAncillaries = async (req: any) => {
	const response = await axios.get(AVAILABLE_ANCILLARIES);
	return response.data;
}

const preAuthReq: any = async (req: any) => {
	const response = await axios.post(PRE_AUTH, req);
	return response.data;
}

const getCustomerData: any = async (req: any) => {
	const response = await axios.post(RA_GET_CUSTOMER_DATA, req);
	return response.data;
}

const updateDraftRA: any = async (req: any) => {
	const recoveryMode = !!req.recoveryMode;
	delete req.recoveryMode;

	let searchParam = recoveryMode ? '?recoveryMode=1' : '';
	if (req.keyless) {
		searchParam += searchParam ? '&' : '?';
		searchParam += `keyless=1&keylessInfo=${encodeURIComponent(req.keyLessInfo || '')}`
	}

	const response = await axios.putForm(RA_UPDATE_DRAFT_DATA + searchParam , req);
	return response.data;
}

const retriveDraftRA: any = async (reqParam: {idRA: string, recoveryMode: boolean, keyLess: boolean}) => {
	let searchParam = reqParam.recoveryMode ? "?recoveryMode=1" : '';
	if (reqParam.keyLess) {
		searchParam += !!searchParam ? '&' : '?';
		searchParam += "keyless=1";
	}
	const response = await axios.get(RA_DRAFT_DATA + reqParam.idRA + searchParam);
	return response.data;
}

const verifySignRa: any = async (idRa: string) => {
	const response = await axios.get(RA_VERIFY_SIGN + idRa);
	return response.data;
}

const checkTransactionRa: any = async (req: { idRentalAgreement: string, isSubstitution: boolean }) => {
	const response = await axios.post(RA_CHECK_TRANSACTION, req);
	return response.data;
}

const fetchPrefixes = async (): Promise<TFetchPrefixesReturn> => {
	const response = await axios.get(RA_PREFIXES_DATA);
	return response.data.data;
}

const fetchCountries: any = async () => {
	const response = await axios.get(RA_COUNTRIES_DATA);
	return response.data.data;
}

const fetchLegalEntities = async (): Promise<IGenericOption[]> => {
	const response = await axios.get(RA_LEGALENTITIES_DATA);
	return response.data;
}

const fetchProvincesByCountryCode: any = async (req: any) => {
	const response = await axios.get(RA_PROVINCES_BY_COUNTRY_DATA.replace('{countryCode}', req.code));
	return { response: response.data.data, field: req.field, billingNumber: req.billingNumber, codeToFind: req.codeToFind };
}

const fetchVerifyEmailMobileOtp: any = async (reqParams: any): Promise<any> => {
	const response = await axios.post(RA_VERIFY_EMAIL_MOBILE_OTP_VALIDATION, reqParams);
	return response.data;
}

const fetchSendOtp: any = async (reqParams: any): Promise<any> => {
	const response = await axios.post(RA_SEND_OTP_VALIDATION, reqParams);
	return response.data;
}

const fetchCheckOtp: any = async (reqParams: any): Promise<any> => {
	const response = await axios.post(RA_CHECK_OTP_VALIDATION, reqParams);
	return response.data;
}

const consentManagement: any = async (req: any) => {
	const response = await axios.post(RA_CONSENT, req,{ headers: { "Content-Type": "multipart/form-data" }});
	return response.data;
}

// PRE-AUTH & PAYMENT
const raPreAuthPaymentVerify = async (req: any) => {
	const response = await axios.post(RA_PREAUTH_PAYMENT_VERIFY, req);
	// return new Promise(function (resolve, reject) {
	// //
	// 		resolve({status: 'OK'});
	// // 		// OR
	// // 		reject({error: 'Errore'})
	// // 		// OR
	// // 		// throw new Error("No work for 0");
	// 	}
	// );
	// return {data: response.data, type: req.type};
	return response.data;
}

const raPreAuthPaymentPreauthorize = async (req: any) => {
	const card = req.type;
	delete req.type;

	const response = await axios.post(RA_PREAUTH_PAYMENT_PREAUTHORIZE + `?creditCard=${card}`, req);
	return response.data
}

const raPreAuthPaymentDispositive = async (req: any) => {
	const response = await axios.post(RA_PREAUTH_PAYMENT_DISPOSITIVE, req);
	return response.data;
}

const raPreAuthPaymentInvoiceDraft = async ({idRA}: {idRA: string}) => {
	const response = await axios.get(RA_PREAUTH_PAYMENT_INVOICE_DRAFT + idRA);
	return response.data;
}

const raPreAuthPriceList = async (reqParams: any) => {
	const response = await axios.get(RA_PREAUTH_PRICE_LIST, { params: reqParams });
	return response.data;
}

const raPreAuthVerifyPaymentStatus = async (reqParams: any) => {
	const response = await axios.post(RA_PREAUTH_VERITY_PAYMENT_STATUS, reqParams);
	return response.data;
}

const raUpdateByCounterSale = async (reqParams: any) => {
	const response = await axios.post(RA_UPDATE_BY_COUNTER_SALE, reqParams);
	return response.data;
}

const fetchVerifyCheckOutAdjusted: any = async (req: any) => {
	const response = await axios.get(RA_VEHICLE_IDENTIFICATION_BY_ID_RA.replace('{id}', req.id).replace('{outin}', req.type));
	return response.data;
}

const vehicleEquipmentDefault: any = async (reqParams: { tenant: string, plate: string, idRentalAgreement: string }) => {
	const response = await axios.get(RA_VEHICLE_EQUIPMENTS_DEFAULT, { params: reqParams });
	return response.data;
}

const vehicleEquipmentCheckOutIn: any = async (reqParams: { tenant: string, plate: string }) => {
	const response = await axios.get(RA_VEHICLE_EQUIPMENTS_CHECK_OUT_IN, { params: reqParams });
	return response.data;
}

const vehicleDamages: any = async (reqParams: { tenant: string, plate: string, vin: string, idRentalAgreement: string }) => {
	const response = await axios.get(RA_VEHICLE_DAMAGES, { params: reqParams });
	return response.data;
}

const raPreViewDownloadPdf = async (reqParams: any) => {
	const response = await axios.get(DOWNLOAD_PDF + reqParams.pdfType, { params: { idRentalAgreement: reqParams.idRentalAgreement, language: reqParams.language }, responseType: 'blob' });
	return response.data;
}

/** QRCode SignRA */
const fetchQrCodeSignRa: any = async (payload: any) => {
	const response = await axios.get(RA_QRCODE_SIGNRA, { params: payload });
	return response.data;
}

const getCustomers = async (params: IGetCustomersParams) => {
	const response = await axios.post(CUSTOMERS, params);
	return response.data;
}

const getCommonPlaces = async (): Promise<TGetCommonPlacesReturn> => {
	const response = await axios.get(COMMON_PLACES);
	return response.data;
}

const getIssuePlaces = async (params: IGetIssuePlacesParams): Promise<TGetIssuePlacesReturn> => {
	const response = await axios.get(ISSUE_PLACES, {
		params
	});
	return response.data;
}

const fetchCreateRaPricingAncillaryInfo = async (params: {idRentalAgreement: string}) => {
	const response = await axios.post(CREATE_RA_PRICING_ANCILLARY_INFO, params);
	return response.data;

	// return new Promise<any>(function (resolve, reject) {
	// 		//
	// 		resolve(
	// 			{
	// 				maxItem: 0,
	// 				amountTaxIncluded: 6000,
	// 				currency: 'EUR'
	// 			}
	// 		);
	// 		// 		// OR
	// 		// 		reject({error: 'Errore'})
	// 		// 		// OR
	// 		// 		// throw new Error("No work for 0");
	// 	}
	// );
}

const fetchCounterSaleManagement = async (reqParams: any) => {
	const response = await axios.post(COUNTER_SALE_MANAGEMENT, reqParams);
	return response.data;
}

const findCounterSaleManagement = async (reqParams: any) => {
	const response = await axios.post(FIND_COUNTER_SALE_MANAGEMENT, reqParams);
	return response.data;
}

const validateDocumentsByOwner = (owner: string) => {
    return axios.put(VALIDATE_DOCUMENTS_DRIVER + `/${owner}`);
}

const fetchBusinessContinuitySkipPayment = async (reqParams: any) => {
	const response = await axios.post(BUSINESS_CONTINUITY_SKIP_PAYMENT, reqParams);
	return response.data;
}

const fetchRaUploadReceipt = async (reqParams: any) => {
	const response = await axios.post(RA_UPLOAD_RECEIPT + `?idRentalAgreement=${reqParams.idRentalAgreement}&operationId=${reqParams.operationId}&operationType=${reqParams.operationType}`, reqParams.receipt);
	return response.data;
}

const fetchRaRecoveryReceipt = async (reqParams: any) => {
	const response = await axios.post(RA_RECOVERY_RECEIPT + `?idRentalAgreement=${reqParams.idRentalAgreement}&type=${reqParams.type}&info=${reqParams.info}`, reqParams.receipt);
	return response.data;
}

const fetchRaCheckInExtra = async (reqParams: { idRentalAgreement: string }) => {
	const response = await axios.get(RA_CHECK_IN_EXTRA + `?idrentalagreement=${encodeURIComponent(reqParams.idRentalAgreement)}`);
	return response.data;
}

export const getCustomerBaseById = (id: any) => {
    return axios.get(`/customer/${id}`);
}

export {
	ra,
	raFilling,
	raKeyless,
	raEdit,
	raCheck,
	listVehiclesReadyToRent,
	fetchAvailableAncillaries,
	preAuthReq,
	getCustomerData,
	updateDraftRA,
	retriveDraftRA,
	verifySignRa,
	checkTransactionRa,
	fetchPrefixes,
	fetchLegalEntities,
	fetchCountries,
	fetchProvincesByCountryCode,
	fetchVerifyEmailMobileOtp,
	fetchSendOtp,
	fetchCheckOtp,
	consentManagement,
	raPreAuthPaymentVerify,
	raPreAuthPaymentPreauthorize,
	raPreAuthPaymentDispositive,
	raPreAuthPaymentInvoiceDraft,
	raPreAuthPriceList,
	fetchVerifyCheckOutAdjusted,
	vehicleEquipmentDefault,
	vehicleDamages,
	raPreViewDownloadPdf,
	vehicleEquipmentCheckOutIn,
	fetchQrCodeSignRa,
	getCustomers,
	getCommonPlaces,
	getIssuePlaces,
	fetchCounterSaleManagement,
	raPreAuthVerifyPaymentStatus,
	fetchCreateRaPricingAncillaryInfo,
	raUpdateByCounterSale,
	findCounterSaleManagement,
	validateDocumentsByOwner,
	fetchBusinessContinuitySkipPayment,
	fetchRaUploadReceipt,
	fetchRaRecoveryReceipt,
	fetchRaCheckInExtra,
}